import { LogIn } from 'lucide-react';
import { useAuth } from '../hooks/useAuth.js';
import { Wordmark } from '../components/landing/Section.js';

export function Login() {
  const { signIn } = useAuth();
  return (
    <div className="app-canvas flex min-h-screen flex-col items-center justify-center px-6 py-12">
      {/* Wordmark above the card, matching the landing nav and footer. */}
      <Wordmark className="mb-8" />

      <div className="card wash-brand w-full max-w-md p-8 shadow-soft-lg sm:p-10">
        <h1 className="font-display text-2xl font-bold leading-tight tracking-tight text-slate-900 sm:text-3xl">
          Cold email that lands in the inbox
        </h1>
        <p className="mt-3 text-slate-600">
          Sequences, deliverability, and AI personalization, sent from your own
          mailbox.
        </p>
        <button
          onClick={() => void signIn()}
          className="mt-7 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-brand-700 px-5 py-2.5 text-sm font-semibold text-white shadow-soft-brand transition duration-200 ease-out hover:bg-brand-800 hover:shadow-soft-md focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/50 focus-visible:ring-offset-2 active:translate-y-px"
        >
          <LogIn className="h-4 w-4" strokeWidth={2} aria-hidden />
          Sign in with Google
        </button>
        <p className="mt-5 text-center text-xs text-slate-400">
          Google Workspace · OAuth · No password sharing
        </p>
      </div>
    </div>
  );
}
